<div class="empty-state">
  <div class="empty-state-icon">
    <mat-icon *ngIf="icon" [ngClass]="{ icon: !isDashboardWidget }">{{ icon }}</mat-icon>
    <img *ngIf="imageSrc" [src]="imageSrc" [alt]="title" />
  </div>
  <h3 [ngClass]="isDashboardWidget ? 'dashboard-title' : 'title'">{{ title }}</h3>
  <p [ngClass]="isDashboardWidget ? 'dashboard-message' : 'message'">{{ message }}</p>
</div>
